<template>
  <v-app>
    <div class="login-page-container">
      <!-- Animated Background Overlay -->
      <div class="background-overlay"></div>

      <div class="login-glass-card">
        <div class="card-content">
          <!-- Branding / Logo Area -->
          <div class="logo-area mb-8">
            <template v-if="this.$route.params.tenant == 'PCUN'">
              <img class="main-logo pcunLogo" src="../../assets/img/logo.png" alt="PCUN" />
            </template>
            <template v-else>
              <img class="main-logo pgsLogo" src="../../assets/img/pgs-logo.png" alt="PGS" />
            </template>
            <h2 class="welcome-text mt-4">Bienvenido</h2>
            <p class="subtitle-text">Por favor, inicie sesión en su cuenta</p>
          </div>

          <!-- Tenant Feedback / Switcher -->
          <div class="tenant-info mb-6" v-if="tenant.tenant">
            <v-btn v-if="tenant.tenant == 'HDRK' || tenant.tenant == 'RIVI'" @click="changeTenant(tenant.tenant)"
              class="tenant-switch-btn" text small>
              <v-icon left size="18">mdi-swap-vertical</v-icon>
              Estás en {{ $pgsHelper.getNombreCampo(tenant.tenant) }}. ¿Cambiar?
            </v-btn>
            <h4 v-else class="tenant-name">{{ $pgsHelper.getNombreCampo(tenant.tenant) }}</h4>
          </div>

          <!-- Error Alert -->
          <v-alert v-if="!tenant.ok" type="error" border="left" colored-border elevation="2" class="mb-6 custom-alert">
            Base de datos no configurada. Por favor, verifique su enlace de acceso.
          </v-alert>

          <!-- Main Login Form -->
          <div v-if="tenant.ok" class="login-form">
            <!-- User Type Selector (Segmented Control Style) -->
            <div class="user-type-selector mb-6">
              <button :class="['type-btn', { active: userType === 1 }]" @click="userType = 1">
                Administrador
              </button>
              <button :class="['type-btn', { active: userType === 2 }]" @click="userType = 2">
                Agencias
              </button>
            </div>

            <!-- Conditional Agency Selection -->
            <v-expand-transition>
              <div v-if="userType === 2" class="agency-selector mb-4">
                <v-autocomplete v-model="selectedHotel" :items="comp_hotel" item-value="id"
                  label="Selecciona tu agencia" outlined rounded dense hide-details class="custom-field"
                  append-icon="mdi-office-building"></v-autocomplete>
              </div>
            </v-expand-transition>

            <!-- Credentials -->
            <div class="input-group">
              <v-text-field v-model="username" label="Usuario" outlined rounded class="custom-field mb-4"
                prepend-inner-icon="mdi-account-outline" hide-details></v-text-field>

              <v-text-field v-model="password" label="Contraseña" :type="show1 ? 'text' : 'password'"
                :append-icon="show1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" @click:append="show1 = !show1" outlined
                rounded class="custom-field mb-6" prepend-inner-icon="mdi-lock-outline" hide-details
                @keyup.enter="login()"></v-text-field>
            </div>

            <!-- Login Action -->
            <v-btn :loading="loading" @click="login()" block x-large rounded class="login-submit-btn">
              Iniciar Sesión
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>


<script>
import FirebaseConfig from "../../helpers/FirebaseConfig.js";
import {
  signInWithEmailAndPassword,
  updateCurrentUser,
  getAuth,
} from "firebase/auth";
const firebaseConf = new FirebaseConfig();
let fSingleton;
import { Crisp } from "crisp-sdk-web";
export default {
  name: "login",
  components: {},
  data() {
    return {
      show1: false,
      tenant: {},
      loading: false,
      username: "",
      password: "",
      userType: 1,
      otherUserType: 1,
      selectedHotel: " ",
      hoteles: [],
      accesso: { dominio: "@admins.golfcourse.com", tipo: "Administrador" },
    };
  },
  props: ["domain", "toMain"],
  methods: {
    changeTenant(tenant) {
      if (tenant == "HDRK") {
        console.log("vengo de HDRK", tenant)
        this.$router.push({ path: "/login/RIVI" }).then(() => { this.$router.go(0) });
      } else if (tenant == "RIVI") {
        console.log("vengo de RIVI", tenant)
        this.$router.push({ path: "/login/HDRK" }).then(() => { this.$router.go(0) });
      }
    },
    async login() {
      if (!this.username || !this.password) {
        this.$swal({
          icon: "warning",
          title: "Campos incompletos",
          text: "Por favor, ingrese su usuario y contraseña",
        });
        return;
      }
      this.loading = true;
      let userTenant = "Admins";
      let dominio = "@admins.pargolfsolutions.com";
      let email = this.username + dominio;
      if (this.userType == 2) {
        dominio = "@mayoristas.pargolfsolutions.com";
        userTenant = "Mayoristas";
        email = this.selectedHotel + "_" + this.username + dominio;
      }

      let authTenant = await firebaseConf.getUserTenantByUserType(
        this.tenant.tenant,
        userTenant
      );

      let defaultApp = getAuth();
      if (authTenant.ok) {
        defaultApp.tenantId = authTenant.userTenant;
      }
      const credential = await signInWithEmailAndPassword(
        defaultApp,
        email,
        this.password.trim()
      ).catch((error) => {
        console.log(error);
      });
      const auth = getAuth(this.$store.state.FirebaseApp.firebaseApp.mainApp);

      if (credential) {
        Crisp.user.setNickname(this.tenant.tenant + '-' + ((credential.user) ? credential.user?.displayName : ""));
        auth.tenantId = authTenant.userTenant // for node 18 firebase 9.23
        await updateCurrentUser(auth, credential.user);
        await this.$store.dispatch('listeners/listenerRVATarifas');
        this.$store.dispatch("listenerProducts");
        this.$store.dispatch("listenerTiposCambio");
        this.$store.dispatch("listenerInventariosWeb", this);
        this.$store.dispatch("listenerCatalogoPermisos");
        this.$store.dispatch("listenerClientes");
        this.$store.dispatch("listenerPDVMonedasLista");
        this.$store.dispatch("listenerPDVPagosTipos");
        this.$store.dispatch("listeners/listenerMBSPlanes");
        this.$store.dispatch("listeners/listenerMBSBeneficios");
        this.$store.dispatch("listeners/listenerMBSMembresias");
        this.$store.dispatch("listeners/listenerMBSPeriodos");
        this.$store.dispatch("getRVADepartamentos");
        this.$store.dispatch("getOrigenes");
        await this.$store.dispatch("getRVACatalogo");
        await this.$store.dispatch("getPDVDepartamentos");
        await this.$store.dispatch("getAfiliados");
        await this.$store.dispatch("listeners/listenerBNKLineas");
        await this.$store.dispatch("modificadores/listenerModificadores");
        this.$router.push({ path: "/" });
      } else {
        this.loading = false;
        this.$swal({
          icon: "error",
          title: "Verifique sus credenciales",
          text: "Por favor, verifique el usuario y la contraseña e intente de nuevo",
        });
      }
    },
    async getHoteles() {
      const data = fSingleton.database.ref("RVA/Mayoristas/Coleccion");
      fSingleton.database.onValue(data, (snapshot) => {
        this.hoteles = [];
        if (snapshot.exists()) {
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
      });
    },
  },
  computed: {
    LoginName() {
      let idHotel = this.$route.params.idHotel;
      let loginName = idHotel ? "Agencia" : "Admin";
      return loginName;
    },
    comp_hotel() {
      let hotel = [{ id: " ", text: "Selecciona tu agencia" }];
      this.hoteles.forEach((ele) => {
        hotel.push({ id: ele.Codigo, text: ele.Nombre });
      });
      return hotel;
    },
  },
  beforeCreate: function () {
    document.body.className = "login";
  },
  async created() {
    fSingleton = this.$store.getters.getFirebaseApp;
    this.getHoteles();
    if (this.$route.params.tenant) {
      let tenatInfo = await firebaseConf.getUrlDatabaseByTenant(
        this.$route.params.tenant
      );
      this.tenant = tenatInfo;
      if (!tenatInfo.ok) {
        const subdomine = firebaseConf.getSubdomain(window.location.hostname)
        const tenantData = await firebaseConf.getTenantBySubdomain(subdomine)
        if (tenantData) {
          firebaseConf.setTenantInLocal(tenantData);
          this.$router.push({ path: "/login/" + tenantData }).then(() => { this.$router.go(0) });
        } else {
          this.$swal({
            icon: "error",
            title: "La base de datos no esta configurada",
            text: "La base de datos para tu cliente no esta configurada, contacte a soporte.",
          });
        }

      } else {
        firebaseConf.setTenantInLocal(tenatInfo.tenant);
      }
    } else {
      const subdomine = firebaseConf.getSubdomain(window.location.hostname)
      const tenantData = await firebaseConf.getTenantBySubdomain(subdomine)
      if (tenantData) {
        firebaseConf.setTenantInLocal(tenantData);
        this.$router.push({ path: "/login/" + tenantData }).then(() => { this.$router.go(0) });
      } else {
        this.$swal({
          icon: "error",
          title: "La base de datos no esta configurada",
          text: "La base de datos para tu cliente no esta configurada, contacte a soporte.",
        });
      }
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

.login-page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  position: relative;
  background: #0f172a;
  font-family: 'Outfit', sans-serif;
  overflow: hidden;
}

.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.45) 0%, transparent 40%),
    radial-gradient(circle at 80% 80%, rgba(126, 34, 206, 0.45) 0%, transparent 40%),
    url("../../assets/img/fondo3.jpg") no-repeat center center / cover;
  filter: blur(10px) brightness(0.6);
  transform: scale(1.1);
  z-index: 0;
}

.login-glass-card {
  position: relative;
  width: 100%;
  max-width: 450px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.125);
  border-radius: 24px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.5);
  padding: 40px;
  z-index: 1;
  transform: translateY(0);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-glass-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 48px 0 rgba(0, 0, 0, 0.6);
}

.card-content {
  text-align: center;
}

.logo-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.main-logo {
  max-width: 200px;
  height: auto;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));
}

.pcunLogo {
  width: 140px;
}

.pgsLogo {
  width: 250px;
}

.welcome-text {
  color: #ffffff;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.subtitle-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
  margin-bottom: 24px;
}

.tenant-info {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 8px;
  display: inline-block;
}

.tenant-name {
  color: #60a5fa;
  font-size: 0.9rem;
  margin: 0;
  font-weight: 600;
}

.tenant-switch-btn {
  color: #60a5fa !important;
  text-transform: none;
  font-weight: 500;
}

/* User Type Selector Styling */
.user-type-selector {
  display: flex;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.type-btn {
  flex: 1;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.type-btn.active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Custom Vuetify Overrides */
.custom-field :deep(.v-input__control) {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
}

.custom-field :deep(fieldset) {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.custom-field :deep(.v-text-field--outlined.v-input--is-focused fieldset) {
  border-color: #ffffff !important;
  border-width: 2px;
}

.custom-field :deep(.v-label) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.custom-field :deep(input) {
  color: #ffffff !important;
}

.custom-field :deep(.v-icon) {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* Login Button */
.login-submit-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.3) !important;
  margin-top: 8px;
}

.login-submit-btn:hover {
  transform: scale(1.02);
  filter: brightness(1.1);
}

.custom-alert {
  background: rgba(239, 68, 68, 0.1) !important;
  border-color: #ef4444 !important;
  color: #fca5a5 !important;
  border-radius: 12px !important;
}

/* Mobile Adjustments */
@media (max-width: 480px) {
  .login-glass-card {
    margin: 20px;
    padding: 24px;
    border-radius: 20px;
  }

  .welcome-text {
    font-size: 1.6rem;
  }
}
</style>
